import { withInstall } from '../../utils/with-install'
import Amap from './amap.vue'

export const ElAmap = withInstall(Amap)
export default ElAmap
